import {DerivedComponent, FormComponentProps, RuleType} from "../../DynamicFormTypes.ts";
import React from "react";
import {ExclusiveCheckbox} from "./ExclusiveCheckbox.tsx";
import {ReadOnlyCalculation} from "./ReadOnlyCalculation.tsx";
import {OverrideableNumberCalculation} from "./OverrideableNumberCalculation.tsx";
import {SometimesSelect} from "./SometimesSelect.tsx";
import {SometimesNumber} from "./SometimesNumber.tsx";

/**
 * Routes derived components to specialized sub-components based on their calculationRule.
 *
 * Groups:
 * - ReadOnlyCalculation: Pure computed values, no user editing (SUM, PERCENT, MIN/MAX, etc.)
 * - OverrideableNumberCalculation:      Calculated with user override capability (adjustments, DOM, etc.)
 * - Sometimes[Select/Number]:  Sets value based on another field's state (VACANT_LOT_*, BASEMENT_ZERO_*)
 * - ExclusiveCheckbox:   Cross-row radio-like behavior (MOST_COMPARABLE)
 */

const DerivedRouterRenderer: React.FC<FormComponentProps<DerivedComponent>> = ({ component }) => {

    switch (component.calculationRule) {
        case RuleType.MOST_COMPARABLE:
            return <ExclusiveCheckbox component={component} />;
        case RuleType.SUM_ALL:
        case RuleType.SUM_RECOMMENDED_REPAIRS:
        case RuleType.SUM_ONE:
        case RuleType.SUM_ABS_ONE:
        case RuleType.PERCENT_OF:
        case RuleType.LOWEST:
        case RuleType.HIGHEST:
        case RuleType.MOST_RECENT:
        case RuleType.MULTIPLY_PERCENT:
            return <ReadOnlyCalculation component={component}/>;

        case RuleType.ADJUSTMENT:
        case RuleType.COMBINED_ADJUSTMENT:
        case RuleType.BASEMENT_ADJUSTMENT:
        case RuleType.GARAGE_ADJUSTMENT:
        case RuleType.DAYS_DIFFERENCE:
        case RuleType.NINETY_DAY_AS_REPAIRED:
            return <OverrideableNumberCalculation component={component}/>;

        case RuleType.SOMETIMES_SELECT:
            return <SometimesSelect component={component}/>;

        case RuleType.SOMETIMES_NUMBER:
            return <SometimesNumber component={component}/>
    }
};

export const DerivedRouter = React.memo(DerivedRouterRenderer);
